module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/minimal@2x.png?70a48613";